// Converts a title into a URL-friendly slug.
// e.g. "Ready to Find the Best IBDP Economics Tutor?" -> "ready-to-find-the-best-ibdp-economics-tutor"
export function slugify(text) {
  if (!text) return "";
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "") // remove punctuation
    .replace(/[\s_]+/g, "-") // spaces/underscores -> dash
    .replace(/-+/g, "-") // collapse multiple dashes
    .replace(/^-|-$/g, ""); // trim leading/trailing dash
}

// Builds the full SEO-friendly URL segment for a blog post: "<slug>-<id>"
// The numeric id is kept at the end so we can reliably fetch the post
// from the API (which only supports lookup by id) without any backend changes.
export function buildBlogSlugPath(blogTitle, blogId) {
  const slug = slugify(blogTitle);
  return slug ? `${slug}-${blogId}` : `${blogId}`;
}

// Given a URL param like "ready-to-find-the-best-ibdp-economics-tutor-8",
// extracts the trailing numeric id ("8").
export function extractIdFromSlugPath(slugPath) {
  if (!slugPath) return null;
  const match = slugPath.match(/-(\d+)$/) || slugPath.match(/^(\d+)$/);
  return match ? match[1] : null;
}
